import { searchFilter } from './searchFilter'

export const mutations = Object.assign({}, searchFilter)
